import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Es explícito o incómodo?',
  answer: 'No. Es íntimo, elegante y profesional.'
}, {
  question: '¿Tenemos que estar los dos presentes?',
  answer: 'Es lo ideal. Si uno no puede, igual te llevas la guía y la dirección.'
}, {
  question: '¿Qué pasa si no puedo asistir en vivo?',
  answer: 'Podrás agregar la clase grabada al finalizar tu compra.'
}, {
  question: '¿Dónde y cómo se realiza?',
  answer: 'Online, en vivo por Zoom. El acceso llega por email.'
}, {
  question: '¿Esto reemplaza una terapia?',
  answer: 'No. Es una inmersión de claridad, reconexión y dirección consciente.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-[#0A0A0A] text-[#FAF7F2]" data-id="element-65">
      <div className="max-w-3xl mx-auto px-4" data-id="element-66">
        <h2 className="text-3xl font-serif text-center mb-12" data-id="element-67">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-68">
          {faqs.map((faq, idx) => <motion.div key={idx} className="border border-[#333] rounded-lg overflow-hidden bg-[#111]" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} data-id="element-69">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#1a1a1a] transition-colors" data-id="element-70">
                <span className="font-medium text-lg" data-id="element-71">{faq.question}</span>
                {openIndex === idx ? <Minus className="w-5 h-5 text-[#C5A55A]" data-id="element-72" /> : <Plus className="w-5 h-5 text-[#C5A55A]" data-id="element-73" />}
              </button>

              <AnimatePresence data-id="element-74">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-75">
                    <div className="p-6 pt-0 text-[#FAF7F2]/70" data-id="element-76">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}